"use client";
"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const useWarning_1 = require("../../hooks/useWarning");
const Target_1 = require("../Target");
exports.IconButton = react_1.default.forwardRef((_a, ref) => {
    var _b;
    var { icon, variant = "fill", disabled = false, shape = "circle", size, sx = {}, "aria-label": ariaLabel } = _a, restProps = __rest(_a, ["icon", "variant", "disabled", "shape", "size", "sx", "aria-label"]);
    const { warnDeprecation } = (0, useWarning_1.useWarning)();
    const consumerStyles = {
        marginInlineStart: sx.marginInlineStart,
        marginInlineEnd: sx.marginInlineEnd,
        mx: sx.mx,
        my: sx.my,
        paddingInlineStart: sx.paddingInlineStart,
        paddingInlineEnd: sx.paddingInlineEnd,
        paddingX: sx.paddingX || 2,
        paddingY: sx.paddingY || 2
    };
    const borderRadius = shape === "square"
        ? "iconButtonBorderRadiusSquare"
        : "iconButtonBorderRadiusCircle";
    const backgroundColor = disabled
        ? "buttonBackgroundColorDisabled"
        : variant === "fill"
            ? "iconButtonBackgroundColor"
            : "transparent";
    // TODO: When we remove the iconButtonColor from the Theme object, we can remove the following logic that allows for the use of iconButtonColor and warns devs in console. -EO
    const theme = (0, foundations_1.useTheme)();
    const iconButtonColor = (_b = theme.colors) === null || _b === void 0 ? void 0 : _b.iconButtonColor;
    if (iconButtonColor) {
        warnDeprecation("`iconButtonColor` is deprecated and will be removed in future versions. Please use `iconButtonColorPrimary` and `iconButtonColorSecondary` instead.");
    }
    // End of todo block - should also remove the reference to iconButtonColor in the below buttonStyles object.
    const buttonStyles = Object.assign({ 
        // layout
        display: "flex", justifyContent: "center", alignItems: "center", borderRadius, 
        // appearance
        background: backgroundColor, color: iconButtonColor
            ? iconButtonColor
            : variant === "fill"
                ? "iconButtonColorPrimary"
                : "iconButtonColorSecondary", borderWidth: 1, borderStyle: "solid", borderColor: variant === "outline" ? "iconButtonOutlineColor" : "transparent", transition: "colorMedium" }, (disabled
        ? {}
        : {
            "&:hover": {
                background: variant === "outline"
                    ? "transparent"
                    : "iconButtonHoverBackgroundColor",
                borderColor: variant === "outline"
                    ? "iconButtonHoverBorderColor"
                    : "transparent"
            },
            "&:active": {
                background: variant === "outline"
                    ? "transparent"
                    : "iconButtonActiveBackgroundColor",
                borderColor: variant === "outline"
                    ? "iconButtonHoverBorderColor"
                    : "transparent"
            },
            "&:focus-visible": {
                background: variant === "outline"
                    ? "iconButtonOutlineBackgroundColor"
                    : "iconButtonBackgroundColor",
                borderColor: "iconButtonFocusBorderColor",
                borderWidth: variant === "outline" && 2
            }
        }));
    return (react_1.default.createElement(Target_1.Target, Object.assign({ ref: ref, sx: Object.assign(Object.assign({}, buttonStyles), consumerStyles), disabled: disabled, "aria-label": ariaLabel }, restProps),
        react_1.default.createElement(foundations_1.Icon, { size: size, icon: icon })));
});
exports.IconButton.displayName = "IconButton";
//# sourceMappingURL=IconButton.js.map